import { render, staticRenderFns } from "./InicioUcEnCasa.vue?vue&type=template&id=89e8d754&scoped=true&"
import script from "./InicioUcEnCasa.vue?vue&type=script&lang=js&"
export * from "./InicioUcEnCasa.vue?vue&type=script&lang=js&"
import style0 from "./InicioUcEnCasa.vue?vue&type=style&index=0&id=89e8d754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e8d754",
  null
  
)

export default component.exports